export default __webpack_public_path__ + "static/media/oze.57d5d4a1.jpeg";